import { removeMilestoneError } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getRemoveMilestoneError(milestone) {
      const req = getState().find(
        ({ milestone: { uuid } }) => uuid === milestone.uuid,
      );

      return req ? req.error : removeMilestoneError;
    },
    isRemoveMilestoneRequestFailure(milestone) {
      const state = getState().find(
        ({ milestone: { uuid } }) => uuid === milestone.uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isRemoveMilestoneRequestPending(milestone) {
      const state = getState().find(
        ({ milestone: { uuid } }) => uuid === milestone.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isRemoveMilestoneRequestSuccess(milestone) {
      const state = getState().find(
        ({ milestone: { uuid } }) => uuid === milestone.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
